export default function InputLabel({
  label,
  htmlFor,
}: {
  label: string;
  htmlFor?: string;
}) {
  return (
    <label htmlFor={htmlFor} className="!text-base !font-Nunito !text-titleText !font-medium pb-2 ">
      {label}
    </label>
  );
}
